/* Built In Imports */
import React from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
/* Styles */
/* Services */

/**
 *
 * @param {Object} sectionContent
 * @param {String} region
 * @param {String} lang
 * @returns
 */
const TopBannerV2 = ({ region, lang, sectionContent }) => {
  // console.log(sectionContent, 'topbane');
  return (
    <Box w="100%" pt={{ base: '0px', md: '80px' }}>
      <Box
        w="100%"
        bgImage={{
          base: sectionContent?.mobileImage?.url,
          md: sectionContent?.image?.url,
        }}
        bgPos="center"
        bgSize="cover"
        height="100vh"
        bgRepeat="no-repeat"
        // maxW={1920}
        maxH={{ base: 200, sm: 400, md: 620 }}
        mx="auto"
      ></Box>
    </Box>
  );
};

export default TopBannerV2;
